var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/artwork") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.6,5.3 C17.759798,5.3 18.7,6.24020203 18.7,7.4 L18.7,16.6 C18.7,17.759798 17.759798,18.7 16.6,18.7 L7.4,18.7 C7.3848722,18.7 7.36978176,18.69984 7.35473028,18.6995217 C7.32764904,18.7005253 7.29982547,18.6997524 7.27211843,18.6973346 C6.17173051,18.629932 5.3,17.7167678 5.3,16.6 L5.3,7.4 C5.3,6.24020203 6.24020203,5.3 7.4,5.3 Z M14.666,11.656 L9.022,17.3 L16.6,17.3 C16.9543827,17.3 17.2472582,17.0366564 17.2936098,16.6949859 L17.3,16.6 L17.3,14.289 L14.666,11.656 Z M16.6,6.7 L7.4,6.7 C7.01340068,6.7 6.7,7.01340068 6.7,7.4 L6.7,16.6 C6.7,16.8823925 6.86721841,17.1257291 7.10803863,17.2363931 L14.1716919,10.1716919 C14.4177222,9.92566162 14.8013298,9.90105859 15.0748756,10.0978828 L15.1616414,10.1716919 L17.3,12.311 L17.3,7.4 C17.3,7.04561729 17.0366564,6.75274177 16.6949859,6.70639017 L16.6,6.7 Z M9.66666667,7.96666667 C10.6055507,7.96666667 11.3666667,8.72778259 11.3666667,9.66666667 C11.3666667,10.6055507 10.6055507,11.3666667 9.66666667,11.3666667 C8.72778259,11.3666667 7.96666667,10.6055507 7.96666667,9.66666667 C7.96666667,8.72778259 8.72778259,7.96666667 9.66666667,7.96666667 Z M9.66666667,9.36666667 C9.50098124,9.36666667 9.36666667,9.50098124 9.36666667,9.66666667 C9.36666667,9.83235209 9.50098124,9.96666667 9.66666667,9.96666667 C9.83235209,9.96666667 9.96666667,9.83235209 9.96666667,9.66666667 C9.96666667,9.50098124 9.83235209,9.36666667 9.66666667,9.36666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/artwork",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork);
export default __webpack_public_path__ + "static/media/artwork.84fffb19d727a3d606600c69a0020495.svg";
export { ForwardRef as ReactComponent };